import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import { Btn, P } from "../../AbstractElements";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { UpgradeMemberService } from "../../Service/UpgradeMember/UpgradeMember";
import { useSweetAlert } from "../../Context/SweetAlertContext";

const UpgradeMemberContainer = () => {
  const location = useLocation();
  const { pin } = location.state || {};
  const navigate = useNavigate();

  // Initialize all service methods you need
  const { upgradeUser, checkPin, checkUser } = UpgradeMemberService();

  const { showAlert, ShowSuccessAlert } = useSweetAlert();
  const [UserName] = useState(localStorage.getItem("UserName"));

  const [user, setUser] = useState({
    username: UserName,
    paidBy: 12345,
  });

  const [userDetails, setUserDetails] = useState({
    name: "N/A",
    email: "N/A",
  });

  const [packageInfo, setPackageInfo] = useState({
    amount: "N/A",
    status: "N/A",
    pin: pin || "N/A",
  });

  const [modal, setModal] = useState(false);
  const [isUpgrading, setIsUpgrading] = useState(false);
  const [isCheckingPin, setIsCheckingPin] = useState(false);
  const [showInvalidMessage, setShowInvalidMessage] = useState(false);

  const toggleModal = () => setModal(!modal);

  useEffect(() => {
    const fetchUserDetails = async () => {
      if (!UserName || !pin) return;

      try {
        const payload = {
          procName: "UpgradebyPin",
          Para: JSON.stringify({
            UserName: UserName,
            Pin: pin,
            ActionMode: "CheckUser",
          }),
        };

        const response = await checkUser(payload);

        if (response && response.length > 0 && response[0].StatusCode === 1) {
          setUserDetails({
            name: response[0].Name,
            email: response[0].Email,
          });
        } else {
          showAlert(
            "User Not Found",
            response?.[0]?.Msg || "The user details could not be retrieved."
          );
        }
      } catch (error) {
        console.error("Failed to check user:", error);
        showAlert("Error", "An error occurred while fetching user details.");
      }
    };

    fetchUserDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [UserName, pin]);

  // Use useEffect to call the API when the component first loads
  useEffect(() => {
    const fetchPinDetails = async () => {
      if (!pin) {
        showAlert("PIN not found.", "Please go back and select a valid PIN.");
        return;
      }

      setIsCheckingPin(true);
      try {
        const response = await checkPin(pin);

        if (response && response.length > 0 && response[0].StatusCode === 1) {
          setPackageInfo({
            amount: response[0].Amount,
            status: response[0].Status,
            pin: response[0].Pin,
          });
        } else {
          showAlert(
            "Invalid PIN",
            response?.[0]?.Msg ||
              "The selected PIN is not valid or has been used."
          );
          setPackageInfo({ amount: "N/A", status: "Invalid", pin: pin });
        }
      } catch (error) {
        console.error("Failed to check PIN:", error);
        showAlert("Error", "An error occurred while fetching PIN details.");
        setPackageInfo({ amount: "N/A", status: "Error", pin: pin });
      } finally {
        setIsCheckingPin(false);
      }
    };

    fetchPinDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pin, showAlert]); // Removed 'checkPin' to prevent infinite loop

  const confirmUpgrade = async () => {
    if (
      !packageInfo.pin ||
      packageInfo.pin === "N/A" ||
      packageInfo.amount === "N/A"
    ) {
      showAlert("Upgrade Not Possible.", "The PIN is not valid or not found.");
      toggleModal();
      return;
    }

    setIsUpgrading(true);
    toggleModal();

    try {
      const payload = {
        UserName: user.username,
        PaidBy: user.paidBy,
        PIN: packageInfo.pin,
      };

      const response = await upgradeUser(payload);

      console.log("Upgrade API Response:", response?.[0]);

      if (
        response &&
        response.length > 0 &&
        String(response[0].StatusCode) === "1"
      ) {
        const upgradeData = response[0];
        ShowSuccessAlert(upgradeData.Msg);

        navigate(`${import.meta.env.BASE_URL}/upgradeSuccess`, {
          state: {
            upgradeId: upgradeData.UpgradeId,
            pin: upgradeData.PIN,
            paidBy: upgradeData.PaidBy,
            upgradeDate: upgradeData.UpgradeDate,
          },
        });
      } else {
        showAlert(
          "Upgrade Failed",
          response?.[0]?.Msg || "Unknown error occurred."
        );
      }
    } catch (error) {
      console.error("Upgrade API call failed:", error);
      showAlert(
        "Upgrade Failed",
        "An error occurred during the upgrade process. Please try again."
      );
    } finally {
      setIsUpgrading(false);
    }
  };

  return (
    <>
      <Breadcrumbs mainTitle="Upgrade Member" parent="Members" />
      <Container fluid>
        <Row>
          <Col xl="12">
            <Card>
              <CardBody>
                <Row>
                  <Col md="4">
                    <div className="mb-4">
                      <Label>User Name</Label>
                      <Input
                        type="text"
                        value={user.username}
                        onChange={async (e) => {
                          const newValue = e.target.value;

                          // update state
                          setUser((prev) => ({
                            ...prev,
                            username: newValue,
                          }));

                          if (newValue.trim() !== "") {
                            try {
                              const payload = {
                                procName: "UpgradebyPin",
                                Para: JSON.stringify({
                                  UserName: newValue,
                                  ActionMode: "CheckUser",
                                }),
                              };

                              const response = await checkUser(payload);

                              if (
                                response &&
                                response.length > 0 &&
                                response[0].StatusCode === 1
                              ) {
                                setUserDetails({
                                  name: response[0].Name,
                                  email: response[0].Email,
                                });
                                setShowInvalidMessage(false); // ✅ hide red message
                              } else {
                                setUserDetails({ name: "N/A", email: "N/A" });
                                setShowInvalidMessage(true); // ✅ show red message
                              }
                            } catch (error) {
                              console.error("Error checking user:", error);
                              setUserDetails({ name: "N/A", email: "N/A" });
                              setShowInvalidMessage(true); // ✅ show red message
                            }
                          } else {
                            setUserDetails({ name: "N/A", email: "N/A" });
                            setShowInvalidMessage(true); // ✅ show red message
                          }
                        }}
                        className="form-control"
                        placeholder="Enter username"
                      />
                    </div>
                  </Col>

                  {userDetails.name !== "N/A" &&
                    userDetails.email !== "N/A" && (
                      <Col md="4">
                        <div
                          className="mb-4"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "12px 16px",
                            borderRadius: "10px",
                            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          {/* Profile SVG circle */}
                          <div
                            style={{
                              backgroundColor: "#0d6efd",
                              borderRadius: "50%",
                              width: "50px",
                              height: "50px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              marginRight: "15px",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="32"
                              height="32"
                              fill="white"
                              viewBox="0 0 16 16"
                            >
                              <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                              <path
                                fillRule="evenodd"
                                d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 
              11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 
              5.468 2.37A7 7 0 0 0 8 1z"
                              />
                            </svg>
                          </div>

                          {/* User details */}
                          <div>
                            <p
                              style={{
                                margin: 0,
                                fontWeight: "bold",
                                fontSize: "1.1rem",
                                color: "#212529",
                              }}
                            >
                              {userDetails.name}
                            </p>
                            <p
                              style={{
                                margin: "2px 0 0",
                                fontSize: "0.95rem",
                                color: "#6c757d",
                              }}
                            >
                              {userDetails.email}
                            </p>
                          </div>
                        </div>
                      </Col>
                    )}

                  <Col md="4" className="mt-2">
                    <Btn
                      className="btn btn-primary mt-0 mt-md-4 rounded-5"
                      onClick={toggleModal}
                      disabled={
                        isCheckingPin ||
                        isUpgrading ||
                        packageInfo.amount === "N/A"
                      }
                    >
                      {isCheckingPin
                        ? "Checking PIN..."
                        : isUpgrading
                        ? "Upgrading..."
                        : "Upgrade"}
                    </Btn>
                  </Col>

                  {/* <Col md="4">
                    <div className="mb-4">
                      <Label>Name</Label>
                      <Input
                        type="text"
                        value={userDetails.name}
                        readOnly
                        className="form-control"
                      />
                    </div>
                  </Col>
                  <Col md="4">
                    <div className="mb-4">
                      <Label>Email</Label>
                      <Input
                        type="text"
                        value={userDetails.email}
                        readOnly
                        className="form-control"
                      />
                    </div>
                  </Col> */}

                  <Col md="12" className="mt-4 mt-md-0 ">
                    <Row>
                      <Col md="4">
                        <Card
                          className="text-center shadow-sm"
                          style={{ borderRadius: "12px", overflow: "hidden" }}
                        >
                          <CardBody>
                            <P className="fw-bold text-white bg-primary p-2 rounded">
                              TopUp Package
                            </P>
                            <div className="d-flex justify-content-between align-items-center my-2">
                              <span>Amount</span>{" "}
                              <span className="fw-bold fs-5">
                                ₹
                                {isCheckingPin
                                  ? "Loading..."
                                  : packageInfo.amount}
                              </span>
                            </div>
                            <div className="d-flex justify-content-between align-items-center my-2">
                              <P> Status:</P>
                              <P>
                                <span
                                  className={`badge ${
                                    packageInfo.status === "Unused"
                                      ? "bg-success"
                                      : "bg-secondary"
                                  }`}
                                >
                                  {isCheckingPin
                                    ? "Loading..."
                                    : packageInfo.status}
                                </span>
                              </P>
                            </div>
                            <div className="d-flex justify-content-between align-items-center my-2">
                              <P> PIN: </P>{" "}
                              <P>
                                <span className="badge bg-warning text-dark">
                                  {packageInfo.pin}
                                </span>
                              </P>
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {showInvalidMessage && (
          <div
            style={{
              position: "fixed",
              bottom: "20px",
              left: "50%",
              transform: "translateX(-50%)",
              backgroundColor: "red",
              color: "white",
              padding: "12px 24px",
              borderRadius: "8px",
              fontWeight: "bold",
              zIndex: 1050,
              boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
            }}
          >
            Not Valid For any Upgrade
          </div>
        )}
      </Container>

      {/* Confirmation Modal */}
      <Modal isOpen={modal} toggle={toggleModal} centered>
        <ModalHeader toggle={toggleModal}>Confirm Upgrade</ModalHeader>
        <ModalBody>
          <p className="text-danger fw-bold">
            Are you sure you want to Upgrade?
          </p>
        </ModalBody>
        <ModalFooter>
          <Button
            color="warning"
            onClick={confirmUpgrade}
            disabled={isUpgrading}
          >
            {isUpgrading ? "Upgrading..." : "Ok"}
          </Button>
          <Button
            color="secondary"
            onClick={toggleModal}
            disabled={isUpgrading}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default UpgradeMemberContainer;
